import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreRoomStateUPR,
} from '../firestore/RoomStateUPR/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateUPR extends ObservableModelWithDecorators<FirestoreRoomStateUPR> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateUPR>
  ) {
    super(repository, doc)
    makeObservable(this)
  }
}
